module.exports = __webpack_public_path__ + "static/media/GenSenRounded-R.67a29e0e.ttc";